import { Injectable } from '@angular/core';
import { PilotPayAuthResponseOptions } from '../types/auth.type';

/**
 * Error handling supporting class.
 */
@Injectable({
	providedIn: 'root'
})
export class SessionService {
	private user: null | PilotPayAuthResponseOptions = null;

	setUser(user: PilotPayAuthResponseOptions): void {
		this.user = user;
	}

	getUser(): PilotPayAuthResponseOptions {
		if (!this.user) {
			throw new Error('User is not set');
		}

		return this.user;
	}
}
